export function getBodyOld(model?: object): string {

    if (!model) return "";

    var propNames = [];
    for (var property in model) {
        if (model.hasOwnProperty(property)) {
            propNames.push(property);
        }
    }
    return JSON.stringify(model, propNames);
}

export function getBody(model?: object): string {

    if (!model) return "";

    return JSON.stringify(model, getModelProperties(model));
}

export function getBodyWithNestedObject(model: object): string {
    return JSON.stringify(model);
}

export function getModelProperties(model?: object): any[] {
    var propNames = [""];
    for (var property in model) {
        if (model.hasOwnProperty(property)) {
            propNames.push(property);
            if (typeof (model as any)[property] === 'object') {
                propNames = [...propNames, ...getModelProperties((model as any)[property])];
            }
        }
    }
    return propNames
}



